var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.adventCalendarFormatterV1 = {
    attached: false,
    attach: function (context) {
      var bg_image_mobile = $('#bg_image_mobile', context).val();

      if (site.client.isMobile && bg_image_mobile) {
        $('#adv_cal_cap_container', context).css('background-image', 'url(' + bg_image_mobile + ')');
      }
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;

      self.$container = $('#adv_cal_cap_container', context);
      self.$calendarWrapper = $('#adv_cal_cap_wrapper', self.$container);
      self.$cardTemplate = $('#adv_cal_cap_card', self.$container);
      self.toutClass = '.tout';
      self.tileClass = '.tile';
      self.$popup = $(); // will be generated
      self.$popupContainer = $('#adv_cal_cap_popup_container', self.$container);
      self.$errorContainer = $('.error-content-wrapper', self.$container);
      self.$loader = $('.loader', self.$container);
      self.offersCount = parseInt($('#offers_count', self.$container).val()) || 0;
      self.promotion_type = 'offer_grid';
      self.offer_image_path = '/media/export/cms/adv_cal';
      self.offers = {};
      self.offersProducts = {};
      self.currentOffer = null;
      self.transaction = {};

      self.init();
    },
    setEvents: function () {
      var self = this;

      $('.active', self.$container).once().click(function (e) {
        e.preventDefault();
        self.$popup.fadeIn();
        $('.popup-content-wrapper', self.$popup).fadeIn();
      });
      $('.js-apply', self.$popup).once().click(function (e) {
        e.preventDefault();
        var link = $(this).data('offer-link');

        self.applyOffer(link);
      });
      $('.js-applied', self.$popup).once().click(function (e) {
        e.preventDefault();
        self.removeOffer();
      });
      $('[data-popup-close]', self.$popup).once().on('click', function (e) {
        e.preventDefault();
        self.$popup.fadeOut();
      });
    },
    getOfferImage: function (offer) {
      var self = this;

      return self.offer_image_path + offer.image;
    },
    getPopupImage: function (offer) {
      var self = this;

      if (self.offerHasSku(offer)) {
        var sku = self.getDefaultSku(offer);
        var product = self.getDefaultProduct(sku);

        return product.IMAGE_SMALL;
      }

      return self.getOfferImage(offer);
    },
    getOfferDescription: function (offer) {
      return offer.offer_grid_description;
    },
    getTitle: function (offer) {
      var self = this;

      if (self.offerHasSku(offer)) {
        var sku = self.getDefaultSku(offer);
        var product = self.getDefaultProduct(sku);

        return product.PROD_RGN_NAME;
      }

      return offer.description;
    },
    renderCalendar: function () {
      var self = this;

      self.$calendarWrapper.empty();
      var offers_arr = [];

      for (var key in self.offers) {
        if (self.offers.hasOwnProperty(key)) {
          offers_arr.push(self.offers[key]);
        }
      }
      self.offers = offers_arr.sort(function (a, b) {
        return a.sort_order - b.sort_order;
      });
      // render empty cards to simulate expired offers
      var expiredCards = self.offersCount - offers_arr.length;

      if (expiredCards > 0) {
        for (var i = 0; i < expiredCards; i++) {
          self.renderCard();
        }
      }
      $.each(self.offers, function (offer_code, offer) {
        self.renderCard(offer);
        if (offer.timing === 'active') {
          self.currentOffer = offer;
        }
      });
      if (self.currentOffer) {
        self.renderPopup();
      }
      self.renderTouts();
      self.setEvents();
      self.$loader.delay(1000).fadeOut('slow');
    },
    renderCard: function (offer) {
      var self = this;

      offer = offer || false;
      var params = {
        offer_timing: 'expired'
      };

      if (offer) {
        params = {
          offer_image: self.getOfferImage(offer),
          offer_timing: offer.timing,
          offer_code: offer.offer_code
        };
      }
      var rendered = site.template.render(self.$cardTemplate.html(), params);

      self.$calendarWrapper.append(rendered);
    },
    renderTouts: function () {
      var self = this;

      $(self.toutClass, self.$container).each(function () {
        var position = parseInt($(this).data('tout-position'));
        var $tout = $(this).clone(true);
        var $tile = $(self.tileClass, self.$calendarWrapper).eq(position - 1);

        if ($tile.length) {
          $tile.after($tout);
        }
      });
    },
    offerHasSku: function (offer) {
      var self = this;

      return Object.keys(self.offersProducts).length &&
        Object.keys(self.offersProducts.skus).length &&
        self.offersProducts.skus[offer.offer_code] &&
        self.offersProducts.skus[offer.offer_code].length;
    },
    getDefaultSku: function (offer) {
      var self = this;

      return self.offersProducts.skus[offer.offer_code][0];
    },
    getDefaultProduct: function (sku) {
      var self = this;

      return self.offersProducts.products[sku.PRODUCT_ID];
    },
    renderPopup: function () {
      var self = this;
      var rendered = site.template.render(self.$popupContainer.html(), {
        title: self.getTitle(self.currentOffer),
        description: self.getOfferDescription(self.currentOffer),
        pop_image: self.getPopupImage(self.currentOffer),
        button_text: self.currentOffer.button_text,
        button_url: self.currentOffer.button_url,
        offer_code: self.currentOffer.offer_code,
        manual: self.currentOffer.activation === 'manual',
        in_cart: self.isOfferInCart(self.currentOffer)
      });

      self.$popup.remove();
      self.$popup = $(rendered);
      self.$container.append(self.$popup);
    },
    isOfferInCart: function (offer) {
      var self = this;

      if (self.transaction.offerCodes) {
        return self.transaction.offerCodes.indexOf(offer.offer_code) === -1 ? 0 : 1;
      }

      return 0;
    },
    applyOffer: function (link) {
      var self = this;

      if (!self.currentOffer) {
        return;
      }
      var params = {
        offer_code: self.currentOffer.offer_code,
        do_not_defer_messages: 1
      };

      if (self.offerHasSku(self.currentOffer)) {
        var sku = self.getDefaultSku(self.currentOffer);

        params.benefits = {
          ChoiceOfSkus: {
            choices: [sku.SKU_ID]
          }
        };
      }
      generic.jsonrpc.fetch({
        method: 'offers.apply',
        params: [params],
        onBoth: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getValue();
          var message = '';

          if (response.inCart) {
            $(document).trigger('trans.get', 'refreshOfferCart');
            message = response.confirm_message || 'Offer successfuly applied!';
            self.setMessage(message);
            self.$popup.fadeOut(5000, function () {
              if (link) {
                window.location.href = link;
              }
              self.init();
            });
          } else {
            message = response.error_message || 'Not eligible for this offer.';
            self.setError(message);
          }
        }
      });
    },
    removeOffer: function () {
      var self = this;

      if (!self.currentOffer) {
        return;
      }
      generic.jsonrpc.fetch({
        method: 'offer.removeOfferByCode',
        params: [
          {
            'offer_code': self.currentOffer.offer_code
          }
        ],
        onBoth: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getValue();

          if (response.offer_code) {
            self.setMessage('Offer successfuly removed!');
            self.$popup.fadeOut(3000, function () {
              self.init();
            });
          }
        }
      });
    },
    setMessage: function (message) {
      var self = this;
      var $target = $('.popup-content-wrapper .messages', self.$popup);

      $target
        .html(message)
        .fadeIn();
    },
    setError: function (message) {
      var self = this;
      var $target = $('.popup-content-wrapper .messages', self.$popup);

      $target
        .addClass('warning')
        .html(message)
        .fadeIn();
    },
    showErrorPopup: function () {
      var self = this;

      self.$errorContainer.fadeIn().css('display', 'table');
      var $container = $('.error-content', self.$errorContainer);

      $(document).mouseup(function (e) {
        if (!$container.is(e.target) && $container.has(e.target).length === 0) {
          self.$errorContainer.fadeOut();
        }
      });
    },
    init: function () {
      var self = this;
      var localePrefix = Drupal.settings.pathPrefix || '';

      if (localePrefix) {
        generic.jsonrpc.url = '/' + localePrefix.slice(0, -1) + '/rpc/jsonrpc.tmpl';
      }
      generic.jsonrpc.fetch({
        method: 'offers.getOffersRpcData',
        params: [
          {
            'offer_type': self.promotion_type,
            'get_products': 1
          }
        ],
        onSuccess: function (jsonRpcResponse) {
          var response = jsonRpcResponse.getValue();

          if (typeof response.offers == 'object') {
            self.offers = response.offers;
          }
          if (typeof response.offersProducts == 'object') {
            self.offersProducts = response.offersProducts;
          }
          if (typeof response.transaction == 'object') {
            self.transaction = response.transaction;
          }
          if (Object.keys(self.offers).length) {
            self.renderCalendar();
          } else {
            self.showErrorPopup();
          }
        },
        onFailure: function () {
          self.showErrorPopup();
        }
      });
    }
  };
})(jQuery);
